module.exports = __webpack_public_path__ + "static/media/logo.20cd5b76.png";